let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1bW9w")).then(() => parcelRequire('Le10t'));